import type { KeyboardEvent } from 'react';

/**
 * Left / Right move the focus between a dialog's action buttons (wrapping),
 * the way a Windows message box answers the arrow keys; Tab keeps working as
 * it always did. Put it on the element that holds the buttons
 * (`<DialogActions onKeyDown={moveAmongButtons}>`). Disabled buttons are
 * skipped; with a modifier held the key is left alone.
 */
export function moveAmongButtons(ev: KeyboardEvent<HTMLElement>): void {
  if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') return;
  if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey) return;
  // A field in DialogActionsBar's leftSlot keeps its own arrow keys.
  if ((ev.target as HTMLElement).closest?.('.dialog-actions-bar-left')) return;
  const buttons = Array.from(ev.currentTarget.querySelectorAll<HTMLButtonElement>('button:not(:disabled)'));
  if (buttons.length < 2) return;
  const n = buttons.length;
  const i = buttons.indexOf(document.activeElement as HTMLButtonElement);
  const step = ev.key === 'ArrowRight' ? 1 : -1;
  const next = i < 0 ? (step === 1 ? 0 : n - 1) : (i + step + n) % n;
  ev.preventDefault();
  buttons[next].focus();
}
